export const useStoreTheme = () => {
  const globalStore = useGlobalStore()

  return globalStore.theme
}
